import React from "react";
import { HeaderModule } from "../components/home/HeaderModule";
import { PersonOutlined } from "@mui/icons-material";
import { TableModule } from "../components/home/TableModule";
import { ActionsBar } from "../components/ActionsBar";
import { useUsers } from "../hooks/useUsers";
import { useLocation } from "react-router-dom";
import { CustomModals } from "../components/CustomModals";

export const Users = () => {

    const { columns, users, addUser } = useUsers();
    const location = useLocation();

    return (
        <>
            <HeaderModule
                icon={<PersonOutlined htmlColor="rgba(0, 0, 0, .6)" />}
                title="Usuarios"
            />

            <ActionsBar 
                addAction={ addUser }
                module={ location?.pathname.split('/').at(-1) }
            />

            <TableModule 
                columns={ columns }
                rows={ users }
                styles={{
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10,
                }}
            />
        </>
    );
};